// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__158h1","choiceBoxes":"toolbarselects_choiceBoxes__3smYb","simpleField":"toolbarselects_simpleField__1U1Ov"};